import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logAnalyticsEvent, logPageView } from "../firebaseConfig";

const destinationTypeFor = (href) => {
  if (href.startsWith("mailto:")) return "email";
  if (href.startsWith("tel:")) return "phone";
  try {
    const destination = new URL(href, window.location.href);
    const { pathname } = destination;
    if (destination.origin !== window.location.origin) return "external";
    if (pathname === "/") return "home";
    if (pathname === "/rentals") return "rentals_index";
    if (pathname.startsWith("/rentals/") || pathname.startsWith("/apply/")) return "rental_detail";
    if (pathname.startsWith("/register")) return "register";
    if (pathname.startsWith("/login")) return "login";
    if (pathname.startsWith("/pricing")) return "pricing";
    if (pathname.startsWith("/contact")) return "contact";
    if (pathname.includes("policy") || pathname.includes("terms") || pathname.includes("guidelines")) return "legal";
    return "internal";
  } catch {
    return "unknown";
  }
};

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    logPageView(pagePath);
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const handleLinkClick = (event) => {
      const link = event.target.closest?.("a[href]");
      if (!link) return;

      const href = link.getAttribute("href") || "";
      if (!href || href === "#" || href.startsWith("javascript:")) return;

      const destinationType = link.dataset.analyticsDestination || destinationTypeFor(href);
      logAnalyticsEvent(link.dataset.analyticsEvent || `site_${destinationType}_link_click`, {
        destination_type: destinationType,
        link_area: link.dataset.analyticsArea,
      });
    };

    document.addEventListener("click", handleLinkClick);
    return () => document.removeEventListener("click", handleLinkClick);
  }, []);

  return null;
};

export default AnalyticsTracker;
